<template>
  <label :class="$style.fileSelect">
    <span :class="[$style.selectButton, {[$style.disabled] : disabled }]">
      <span :class="$style.inputFileLabel">
        <app-svg-icon name="ic_upload"
                      :class="$style.uploadIcon" />
        Add Files
      </span>
    </span>
    <input type="file"
           ref="fileInput"
           :disabled="disabled"
           :accept="acceptFiles"
           multiple
           @input="handleFileChange" />
  </label>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    acceptFiles: {
      type: String,
      required: false,
    },
  },
  methods: {
    handleFileChange(e) {
      this.$emit('input', e.target.files);
      this.reset();
    },
    reset() {
      const input = this.$refs.fileInput;
      input.type = 'text';
      input.type = 'file';
    },
  },
};
</script>

<style lang="scss" module>
@import "@/styles/variables.scss";

.fileSelect {
  display: flex;
  align-items: center;
  margin-top: 16px;
  cursor: pointer;

  .selectButton {
    padding: 7px 20px;
    background: $accent-button-gradient;
    border: $accent-button-border;
    color: $white-color;
    font-family: $title-font;
    font-size: 1.4rem;
    line-height: 1.6rem;
    text-align: center;
    box-shadow: $accent-button-shadow;
    outline: none;
    transition: all 0.25s ease-in-out;

    &:hover,
    &:focus,
    &:active {
      background: $accent-button-active-gradient;
      border: $accent-button-active-border;
    }

    &:disabled {
      background: $accent-button-disabled-gradient;
      border: $accent-button-disabled-border;
    }

    &.disabled {
      background: $accent-button-disabled-gradient;
      border: $accent-button-disabled-border;
      cursor: default;
    }
  }

  input[type="file"] {
    display: none;
  }

  .inputFileLabel {
    display: flex;
    align-items: center;
  }

  .uploadIcon {
    width: 12px;
    height: 16px;
    margin-right: 12px;
  }
}

</style>
